import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Sound from 'react-sound';
import { blankSound } from 'globals/assets';

class PlaySound extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSoundAllowed: false,
    };
  }

  componentDidMount() {
    if (Audio) {
      const audio = new Audio(blankSound);
      try {
        audio
          .play()
          .then(() => {
            this.setState({
              isSoundAllowed: true,
            });
          })
          .catch(() => {
            this.setState({
              isSoundAllowed: false,
            });
          });
      } catch (error) {
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({
          isSoundAllowed: false,
        });
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }

  render() {
    const { url, play, onFinish } = this.props;
    const { isSoundAllowed } = this.state;

    const isPlaying = play ? Sound.status.PLAYING : Sound.status.STOPPED;

    if (!isSoundAllowed) {
      return null;
    }

    return <Sound url={url} playStatus={isPlaying} onFinishedPlaying={onFinish} />;
  }
}

PlaySound.propTypes = {
  url: PropTypes.string,
  play: PropTypes.bool,
  onFinish: PropTypes.func,
};

PlaySound.defaultProps = {
  url: '',
  play: false,
  onFinish: () => {},
};

export default PlaySound;
